// French for the people board. The record's own content is French, so this catalogue is the
// one that has to agree with the data on screen. Keys already in i18n/common.fr.ts are not
// repeated here.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── the masthead ──
  'ranked by the rule that fired': 'classé selon la règle qui s’est déclenchée',
  'candidates': 'candidats',
  'name is the last tie-break': 'le nom ne départage qu’en dernier',
  'New person': 'Nouvelle personne',

  // ── the rail ──
  'Candidates': 'Candidats',
  'Ball': 'Balle',
  // 'Cooling' is TodayPage's word (Refroidissement) — registered there, not repeated here.
  'New · 7d': 'Nouveaux · 7 j',
  '{orgs} organisations · {a} tier A': '{orgs} organisations · {a} de niveau A',
  'named by evidence · not on the record': 'nommés par des preuves · hors dossier',
  'nothing proposed itself as a person': 'rien ne s’est proposé comme personne',
  'the candidates could not be read': 'les candidats n’ont pas pu être lus',
  'us · {n} late': 'nous · {n} en retard',
  '{n} with them': '{n} chez eux',
  'past their tier cadence · {a} of them tier A': 'au-delà de la cadence de leur niveau · dont {a} de niveau A',
  'nobody is past their tier cadence': 'personne n’a dépassé la cadence de son niveau',
  '{i} from the import · {o} from you': '{i} de l’import · {o} de vous',
  'the board is still loading': 'le tableau charge encore',
  'the board did not answer': 'le tableau n’a pas répondu',
  'The board did not answer': 'Le tableau n’a pas répondu',

  // ── the chips and the search ──
  'Needs a move': 'Demande un geste',
  'Tier A': 'Niveau A',
  'Everyone': 'Tout le monde',
  'Name, organisation, role, ref…': 'Nom, organisation, fonction, référence…',
  'Search people': 'Rechercher des personnes',

  // ── the zone and the rows ──
  'the lead card is the person the data says to write to first':
    'la carte de tête est la personne à qui les données disent d’écrire en premier',
  'Last contact': 'Dernier contact',
  'Tier': 'Niveau',
  'no organisation on record': 'aucune organisation au dossier',
  'ball': 'balle',
  'late since': 'en retard depuis',
  'last interaction {date}': 'dernier échange {date}',
  'no interaction on record': 'aucun échange au dossier',
  'Show {n} more': 'Afficher {n} de plus',
  '{shown} of {total} shown': '{shown} sur {total} affichées',
  'One row matched, and it is the card above.': 'Une seule ligne correspond, c’est la carte ci-dessus.',

  // ── the states a row can be in ──
  'cooling': 'refroidit',
  'new': 'nouveau',
  'warm': 'chaud',
  'quiet': 'silencieux',

  // ── the empty states ──
  'Nobody matches': 'Personne ne correspond',
  'The filter is “{chip}”{q}{cells}. There are {n} people on the record.':
    'Le filtre est « {chip} »{q}{cells}. Le dossier compte {n} personnes.',
  ' and the search is “{q}”': ' et la recherche est « {q} »',
  ' and the cells are {cells}': ' et les cellules sont {cells}',
  'Nobody on the record yet': 'Personne au dossier pour l’instant',
  'A person arrives from the seed import, from a held candidate proposal, or from New person. Until one of those happens this register is genuinely empty.':
    'Une personne arrive par l’import initial, par une proposition de candidat retenue, ou par « Nouvelle personne ». Tant que rien de cela n’a eu lieu, ce registre est réellement vide.',
  'Nobody needs a move. A person appears here when the ball is with us, when it is late, or when they have cooled past their tier’s cadence.':
    'Personne ne demande un geste. Une personne apparaît ici quand la balle est chez nous, quand elle est en retard, ou quand elle a refroidi au-delà de la cadence de son niveau.',

  // ── candidates ──
  'named by evidence, not on the record · promote or refuse in Review':
    'nommés par des preuves, hors dossier · à retenir ou refuser dans la revue',
  'not on the record': 'hors dossier',
  'Promote to person': 'Promouvoir en personne',
  'Holds {ref} and writes the row': 'Retient {ref} et écrit la ligne',
  'No proposal behind this row — its status is flipped directly':
    'Aucune proposition derrière cette ligne — son statut est basculé directement',
  'No candidate matches the search. {n} are waiting.':
    'Aucun candidat ne correspond à la recherche. {n} attendent.',
  'Nothing has proposed itself as a person. Candidates arrive from a lookalike run or a registry publication, and they stay off the record until you promote one.':
    'Rien ne s’est proposé comme personne. Les candidats viennent d’un passage de similarité ou d’une publication au registre, et restent hors dossier tant que vous n’en promouvez aucun.',
  '{name} is on the record. {ref} is held.': '{name} est au dossier. {ref} est retenue.',
  '{name} is on the record.': '{name} est au dossier.',

  // ── round 2 (§10) : la case du score et le tri « Par score » ──
  'Sort': 'Tri',
  'By rule': 'Par règle',
  'By score': 'Par score',
  'Order by the rule that fired: late, then ours, then cooling.':
    'Ordonner selon la règle qui a déclenché : en retard, puis chez nous, puis en refroidissement.',
  'Order by the score the rules produced. Somebody nobody has scored sorts last.':
    'Ordonner selon le score produit par les règles. Une personne non notée passe en dernier.',
  'Score': 'Score',
  'score': 'score',
  'not scored': 'non noté',

  // ── the new-person dialogue ──
  'Add to the record': 'Ajouter au dossier',
  'Name': 'Nom',
  'Full name as they write it': 'Nom complet tel que la personne l’écrit',
  'A person needs a name.': 'Une personne a besoin d’un nom.',
  '{name} added as {ref}.': '{name} ajoutée sous {ref}.',
  'A · 30 day cadence': 'A · cadence 30 jours',
  'B · 90 day cadence': 'B · cadence 90 jours',
  'C · 180 day cadence': 'C · cadence 180 jours',
  'The person is written with the correspondence language French and no affiliation. Attach an organisation and set the register from their brief.':
    'La personne est écrite avec le français comme langue de correspondance et sans rattachement. L’organisation et le registre se règlent depuis sa fiche.',

  // ── round 3b : le filtre d’arbre ──
  'In the tree of {name}': 'Dans l’arbre de {name}',
  'Everyone affiliated with {name} or with a unit under it. Click to see the whole register again.':
    'Toutes les personnes rattachées à {name} ou à une unité en dessous. Cliquer pour revoir tout le registre.',
  'The tree could not be read: {error}': 'L’arbre n’a pas pu être lu : {error}',
  'The tree could not be read.': 'L’arbre n’a pas pu être lu.',

  // ── round 7 §6.2 : les filtres de cellules et le compte honnête ──
  // Les noms de cellules et les tokens viennent de person-raster.v1.ts (personLabelFor) et ne
  // figurent JAMAIS ici : une deuxième orthographe d’une cellule est précisément ce que le
  // raster existe pour empêcher.
  'Cells': 'Cellules',
  'any': 'indifférent',
  'Clear cells': 'Réinitialiser les cellules',
  'Ask the register nothing about its cells again; the chips and the search stay as they are.':
    'Ne plus poser de question de cellule au registre ; les pastilles et la recherche restent telles quelles.',
  '{rank} and above': '{rank} et au-dessus',
  'estimated': 'estimé',
  'from the title': 'depuis le titre',
  'counted on {cells} · over {n} people the cell filters match':
    'compté sur {cells} · sur {n} personnes retenues par les filtres de cellules',
  'the cell count could not be read: {error}': 'le compte des cellules n’a pas pu être lu : {error}',
  '{cell}: {value} · read from a source': '{cell} : {value} · lu sur une source',
  '{cell}: {value} · estimated by an agent': '{cell} : {value} · estimé par un agent',
  '{cell}: {value} · computed by the nightly job': '{cell} : {value} · calculé par le travail de nuit',
  '{cell}: {value} · declared by you': '{cell} : {value} · déclaré par vous',
  '{cell}: {value} · searched for and not found': '{cell} : {value} · cherché et non trouvé',
}, 'PeoplePage');
